import {Component, OnInit, isDevMode} from '@angular/core';
import {AuthenticationService} from './_services/index';
import '../assets/app.css';
import { TranslateService } from '@ngx-translate/core';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-web',
  templateUrl: 'app.component.html'
})

export class AppComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService,private translate: TranslateService) {
    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    }
    translate.setDefaultLang('en');

  }

  ngOnInit() {
    if (isDevMode()) {
      // console.log('%c development stage! ', 'background: #222; color: #bada55');
    } else {
      // console.log('%c final product! ', 'background: #222; color: #bada55');
    }
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts